import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import VueMarkdown from 'vue-markdown';
import CardSet from '@/components/CardSet.vue';
import Loading from '@/components/Loading.vue';
const deploymentsModule = namespace('deployments');
const blobsModule = namespace('blobs');
let StarshipDeployments = class StarshipDeployments extends Vue {
    created() {
        this.fetchStarshipBlob('Deployments');
        this.fetchDeployments();
    }
    get blob() {
        return this.starshipBlobs['Deployments'];
    }
    get deploymentsWithLinks() {
        return this.deployments.map(deployment => ({
            ...deployment,
            to: `deployments/${deployment.name}`
        }));
    }
};
__decorate([
    deploymentsModule.State
], StarshipDeployments.prototype, "deployments", void 0);
__decorate([
    deploymentsModule.Action
], StarshipDeployments.prototype, "fetchDeployments", void 0);
__decorate([
    blobsModule.State
], StarshipDeployments.prototype, "starshipBlobs", void 0);
__decorate([
    blobsModule.Action
], StarshipDeployments.prototype, "fetchStarshipBlob", void 0);
StarshipDeployments = __decorate([
    Component({
        components: {
            VueMarkdown,
            Loading,
            CardSet
        }
    })
], StarshipDeployments);
export default StarshipDeployments;
